import { render, staticRenderFns } from "./ProductConfirmationModal.vue?vue&type=template&id=82aa23b4"
import script from "./ProductConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ProductConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports